"use strict";
/**
 * Bankruptcy Definition Codes
 * Realized these were on form 101, so just making a dictionary for any/all
 * Updated Mar 26, 2021
 *
 * https://www.law.cornell.edu/uscode/text/11/101
 */

module.exports = [{
  codeName: "11 U.S.C. § 101(27A)",
  description: "Health Care Business",
  businessCode: true // used for a Form 101 question regarding sole proprietorships

}, {
  codeName: "11 U.S.C. § 101(51B)",
  description: "Single Asset Real Estate",
  businessCode: true // used for a Form 101 question regarding sole proprietorships

}, {
  codeName: "11 U.S.C. § 101(53A)",
  description: "Stockbroker",
  businessCode: true // used for a Form 101 question regarding sole proprietorships

}, {
  codeName: "11 U.S.C. § 101(6)",
  description: "Commodity Broker",
  businessCode: true // used for a Form 101 question regarding sole proprietorships

}];